import {
  LOGIN_WITH_OTP_REQUEST,
  LOGIN_WITH_OTP_SUCCESS,
  LOGIN_WITH_OTP_FAILURE,
  CLEAR_LOGIN_WITH_OTP,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  CLEAR_VERIFY_OTP,
  RESEND_OTP_REQUEST,
  CLEAR_RESEND_OTP,
  RESEND_OTP_FAILURE,
  RESEND_OTP_SUCCESS,
} from "./actionTypes";

const initialState = {
  ISLOADING: false,
  ISFAILURE: false,
  MobileLoginData: [],
};

export function loginWithOtpReducer(state = initialState, { type, payload }) {
  switch (type) {
    case LOGIN_WITH_OTP_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case LOGIN_WITH_OTP_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        MobileLoginData: payload,
        ISFAILURE: false,
      };

    case LOGIN_WITH_OTP_FAILURE:
      return { ...state, ISLOADING: false, ISFAILURE: true };

    case CLEAR_LOGIN_WITH_OTP:
      return {
        ...state,
        MobileLoginData: [],
      };

      // ✅ Verify OTP cases
    case VERIFY_OTP_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        OtpVerificationData: payload,
        ISFAILURE: false,
      };

    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        ISLOADING: false,
        ISFAILURE: true,
        OtpVerificationData: null,
      };

    case CLEAR_VERIFY_OTP:
      return {
        ...state,
        OtpVerificationData: null,
      };
      // 🔁 Resend OTP
    case RESEND_OTP_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case RESEND_OTP_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        ResendOtpData: payload,
        ISFAILURE: false,
      };

    case RESEND_OTP_FAILURE:
      return {
        ...state,
        ISLOADING: false,
        ISFAILURE: true,
        ResendOtpData: null,
      };

    case CLEAR_RESEND_OTP:
      return {
        ...state,
        ResendOtpData: null,
      }; 


    default:
      return state;
  }
}
